// extracted by mini-css-extract-plugin
export default {"button":"toggle_button__nS7h-","expanded":"toggle_expanded__3e3L+","svg":"toggle_svg__QbbOQ"};